import {initialize} from '../initialize';
import type {AppConfig} from '../initialize';
import type {RLoggerInboundPayload as InboundPayload} from '../../shared/RLoggerTypes';

// new:   The iframe has just been created, we have not yet validated the origin domain, we will queue up all logs
// valid: We have validated the origin domain, we can now start sending logs
// error: There was an error in the validation, most likely an invalid origin domain, the we will drop all logs
let state: 'new' | 'valid' | 'error' = 'new';

let messageQueue: Array<string> = [];

const PORTAL_DOMAINS = [
  'billing.stripe.com',
  'qa-billing.stripe.com',
  'preprod-billing.stripe.com',
  'edge-billing.stripe.com',
];

const sendLog = async (message: string) => {
  fetch('https://r.stripe.com/0', {
    method: 'POST',
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    body: message,
    credentials: 'omit',
  });
};

const RLogger = async (action: InboundPayload) => {
  const currentUrl = new URL(location.ancestorOrigins[0]);
  if (state === 'new' && PORTAL_DOMAINS.includes(currentUrl.host)) {
    state = 'valid';
  }
  if ('key' in action && state === 'new') {
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${action.key}`,
      },
    };

    await fetch(
      'https://api.stripe.com/v1/custom_domains/allowed_origins',
      options,
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.domains.includes(currentUrl.host)) {
          state = 'valid';
          // send all the queued logs
          messageQueue.forEach((message) => {
            sendLog(message);
          });
          messageQueue = [];
        } else {
          state = 'error';
        }
      })
      .catch(() => {
        state = 'error';
      });
  } else if ('body' in action) {
    if (state === 'new') {
      // Queue up messages until we validate the domain
      messageQueue.push(action.body);
    } else if (state === 'valid') {
      await sendLog(action.body);
    }
  }
};

const app = ({subscribe}: AppConfig<'RLogger'>) => {
  subscribe(async (messageData) => {
    await RLogger(messageData);
  });
};

initialize({
  app,
  owner: 'customer_portal',
});
